(() => {
  const key = 'elvyora-favorites-v1';
  const text = JSON.parse(document.getElementById('elvyora-favorites-text')?.textContent || '{}');
  const status = document.getElementById('ev-favorites-status');
  const root = window.Shopify?.routes?.root || '/';
  let handles = [];
  let revision = 0;
  function read() {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(stored) ? [...new Set(stored.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)))].slice(0,200) : [];
    } catch { return []; }
  }
  function announce(message) { if(status) status.textContent = message || ''; }
  function syncButtons() {
    document.querySelectorAll('[data-favorite-handle]').forEach(button => {
      const saved = handles.includes(button.dataset.favoriteHandle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? text.remove : text.add) + (button.dataset.productTitle ? ' — ' + button.dataset.productTitle : ''));
      if(button.dataset.favoriteRemove !== undefined && button.textContent !== text.remove) button.textContent = text.remove;
    });
    document.querySelectorAll('[data-favorite-count]').forEach(el => {const count=handles.length ? '(' + handles.length + ')' : '';if(el.textContent !== count) el.textContent=count;});
  }
  function element(tag, className, content) {
    const el = document.createElement(tag);
    if(className) el.className = className;
    if(content) el.textContent = content;
    return el;
  }
  async function render() {
    const page = document.querySelector('[data-favorites-page]');
    if(!page) return;
    const version = ++revision;
    const list = [...handles];
    const grid = page.querySelector('[data-favorites-grid]');
    const empty = page.querySelector('[data-favorites-empty]');
    const loading = page.querySelector('[data-favorites-loading]');
    grid.replaceChildren(); empty.hidden = !!list.length; loading.hidden = !list.length;
    const results = await Promise.all(list.map(async handle => {
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin'});
        if(response.status === 404) return {handle,missing:true};
        if(!response.ok) throw new Error('unavailable');
        return {handle,product:await response.json()};
      } catch { return {handle,error:true}; }
    }));
    if(version !== revision) return;
    loading.hidden = true;
    for(const result of results) {
      const card = element('article','ev-favorites-item');
      if(result.product) {
        const p = result.product;
        const link = element('a'); link.href = root + 'products/' + result.handle;
        if(p.featured_image) { const img = element('img'); img.src = p.featured_image; img.alt=p.title; img.loading='lazy'; img.width=600; img.height=750; link.append(img); }
        link.append(element('h2',null,p.title));
        const currency = window.Shopify?.currency?.active || 'CHF';
        link.append(element('p',null,new Intl.NumberFormat(document.documentElement.lang || 'fr-CH',{style:'currency',currency}).format(p.price/100)));
        link.append(element('span',null,text.view + ' ↗')); card.append(link);
      } else card.append(element('p',null,result.error ? text.retry : text.unavailable));
      const remove = element('button',null,text.remove); remove.type='button'; remove.dataset.favoriteHandle=result.handle; remove.dataset.favoriteRemove=''; remove.className='ev-favorite-remove'; remove.style.minHeight='44px'; card.append(remove); grid.append(card);
    }
    syncButtons();
  }
  handles = read(); syncButtons(); render();
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-favorite-handle]');
    if(button) {
      event.preventDefault(); event.stopPropagation();
      const handle=button.dataset.favoriteHandle;
      if(!/^[a-z0-9-]+$/.test(handle)) return;
      const current=read(); const saved=current.includes(handle);
      const next=saved ? current.filter(h=>h!==handle) : [...current,handle];
      try {localStorage.setItem(key,JSON.stringify(next)); handles=next; syncButtons(); render(); announce(saved ? text.removed : text.saved);}
      catch {announce(text.error);}
      return;
    }
    const view=event.target.closest('[data-look-src]');
    if(view) {
      const card=view.closest('[data-look]'); const img=card.querySelector('.ev-look-image');
      img.removeAttribute('srcset'); img.src=view.dataset.lookSrc;
      card.querySelectorAll('[data-look-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===view)));
    }
    const zoom=event.target.closest('[data-look-zoom]');
    if(zoom) {const card=zoom.closest('[data-look]'); const dialog=card.querySelector('dialog');const img=dialog.querySelector('img');img.removeAttribute('srcset');img.src=card.querySelector('.ev-look-image').src;dialog.showModal();}
    const close=event.target.closest('[data-look-close]'); if(close) close.closest('dialog').close();
    if(event.target.matches('dialog[data-look-dialog]')) event.target.close();
  });
  window.addEventListener('storage',event=>{if(event.key===key){handles=read();syncButtons();render();}});
  document.addEventListener('shopify:section:load',syncButtons);
  new MutationObserver(syncButtons).observe(document.body,{childList:true,subtree:true});
})();
